import { Env } from '../env';
import { AsCart, AsCartParameter, AsCartItem } from '../../item/models/large_commercial_pack_env';
import { ApiClient } from '../http/api_client';
import { SiteTypeValue } from '../models/js_env';

export class AsCartRepository {
  /// 集客検索PF.カゴ共通.カゴボタン押下のカゴ投入APIを実行し、戻り値を取得する
  /// @param supplierId サプライヤID
  /// @param catalogItemCode カタログ商品コード
  /// @param quantity 数量
  /// @param siteType サイト区分
  /// @return カゴ投入APIの戻り値
  async getClickCartButton(
    supplierId: string,
    catalogItemCode: string,
    quantity: number,
    siteType: SiteTypeValue,
    soloelRcmndFldrId: string | null,
  ): Promise<AsCart> {
    /// カゴ投入APIのRequestを設定
    const clickCartButtons = createClickCartButtonRequest(
      supplierId,
      catalogItemCode,
      quantity,
      siteType,
      soloelRcmndFldrId
    );
    return await ApiClient.post(`${Env.SETTING.userPublicApi.urlBase}api/attract/asCart/asCartButton/`, clickCartButtons);
  }

  /// まとめてカゴに入れる処理
  /// 集客検索PF.カゴ共通.カゴボタン押下のカゴ投入APIを実行し、戻り値を取得する
  /// @param items カゴ投入アイテム情報
  /// @param siteType サイト区分
  /// @return カゴ投入APIの戻り値
  async getClickCartTogetherButton(
      items: AsCartItem[],
      siteType: SiteTypeValue,
      soloelRcmndFldrId: string | null,
  ): Promise<AsCart> {
    /// カゴ投入APIのRequestを設定
    return await ApiClient.post(
      `${Env.SETTING.userPublicApi.urlBase}api/attract/asCart/asCartButton/`,
      new AsCartParameter(items, siteType, soloelRcmndFldrId)
    );
  }
}

/// @param supplierId サプライヤID
/// @param catalogItemCode カタログ商品コード
/// @param quantity 数量
/// @param siteTypeサイト区分
/// @return カゴ投入APIのRequestパラメータ(アイテム単数)
const createClickCartButtonRequest = (
  supplierId: string,
  catalogItemCode: string,
  quantity: number,
  siteType: SiteTypeValue,
  soloelRcmndFldrId: string | null,
) => {
  const items: AsCartItem[] = [new AsCartItem(supplierId, catalogItemCode, quantity)]
  return new AsCartParameter(items, siteType, soloelRcmndFldrId);
};
